import { clsx } from 'clsx';
import { ReactNode } from 'react';

interface Props {
    children: ReactNode;
    className?: string;
}

export const Heading2 = ({ children, className }: Props) => {
    return <h2 className={clsx('', className)}>{children}</h2>;
};
